const titles = ["Mr", "Mrs", "Miss", "Ms", "Adv", "Dr", "Prof", "Capt", "Gen"];

export default titles;